var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmail(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05001 45.0001H13.5V21.8242L0 11.5996V40.9102C0 43.1733 1.81576 45.0001 4.05001 45.0001Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9001 45.0001H55.3501C57.5914 45.0001 59.4002 43.1664 59.4002 40.9102V11.5996L45.9001 21.8242",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9001 4.10146V21.8241L59.4002 11.5995V6.1464C59.4002 1.0886 53.6831 -1.79475 49.6802 1.23856",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.8241V4.10144L29.7001 16.371L45.9 4.10144V21.8241L29.7001 34.0937",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.1464V11.5995L13.5 21.8241V4.10146L9.72003 1.23856C5.71052 -1.79475 0 1.0886 0 6.1464Z",
    fill: "#C5221F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.3c76d61a.svg";
export { ForwardRef as ReactComponent };